$(function () {
	//var dir = "https://knot-designs.com";
	// $("#header").load("../common/inc/header.html", function (data, status) { });
	//$("#header").load(dir + "/common/inc/header-renewal.html", function (data, status) { });
	//$("#footer").load(dir + "/common/inc/footer-renewal.html", function (data, status) { });

	//$.getScript(dir + "/common/add2.js", function () { });
	//$.getScript(dir + "/common/add1.js", function () { });

	$("a.encode").each(function () {
		var url = $(this).attr("href");
		$(this).attr("href", encodeURI(url));
	});

    $('a[href^="#"]:not([data-lity])').click(function(){
      var adjust = $('#header').innerHeight() + 20;
      var speed = 400;
      var href= $(this).attr("href");
      var target = $(href == "#" || href == "" ? 'html' : href);
      var position = target.offset().top - adjust;
      $('body,html').animate({scrollTop:position}, speed, 'swing');
      return false;
    });
});

// $(window).on('load', function () {

// 	smsl = function (href) {
// 		var target = $(href == "#" || href == "" ? 'html' : href);
// 		$("html, body").animate({ scrollTop: target.offset().top - $("#header").innerHeight() }, 500, "swing");
// 	}

// 	if (location.hash) {
// 		$("html, body").css({ scrollTop: 0 });
// 		smsl(location.hash);
// 	}

// 	$(document).on('click', 'a[href^="#"]', function () {
// 		var events = $._data($(this).get(0), "events");

// 		if (events == null) {
// 			smsl($(this).attr("href"));
// 			return false;
// 		}
// 	});

// });

/* end */